import { ContestAndIncentiveDetailsService } from '../services/contest-and-incentive-details.service';
import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { StepItem } from 'src/app/models/common/step-item';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { KeyValue, Location } from '@angular/common';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseStepFormComponent } from 'src/app/system-common/base-step-form/base-step-form.component';
// import { DynamicEvaluationComponentList } from '../services/dynamic-component-list';

@Component({
  selector: '',
  template: '',
})
export class EvaluationDetailsHandler
  extends BaseStepFormComponent<ContestAndIncentiveDetailsService>
  implements OnChanges
{
  public agentId: any;
  public agentName: string;
  public rewardValue: string;
  public parentNode;
  public selectedMenuNode;
  public activeNode: any;
  public expandedNodes = {};
  public menuData: any[] = [];
  public activeCard: any = null;
  public evaluationId;
  public data;
  public subDetailsData;
  public dataValues = [];
  public subMenuDataValues = [];
  public subMenuDataKeys;
  public isMenuOpened: boolean;
  public policyDataValues = [];
  public detailsDataKeys;
  public detailsDataValues = [];
  public childHeader;
  public parentHeader;
  public isNodata;
  public noDataErrorMsg;
  public subtdata;
  public preferredDetailOrders: string[] = [
    'detailDescription',
    'productionEffectiveDt',
    'baseKpiOriginalValue',
    'baseKpiFinalValue',
  ];
  public preferredOrders: string[] = [
    'policyNum',
    'productionEffectiveDt',
    'baseKpiOriginalValue',
    'baseKpiFinalValue',
    'policyStatusCd',
    'productClass1',
  ];
  public preferredKeys: string[] = [];

  public excludedKeys: string[] = [
    'policyNum',
    'productionEffectiveDt',
    'baseKpiOriginalValue',
    'baseKpiFinalValue',
    'policyStatusCd',
    'productClass1',
    'isSelected',
    'appropriationDt',
    'loginDt',
    'policyIssueDt',
    'policyYearInforce',
    'premiumDueDt',
    'premiumSubtypeCd',
    'premiumTypeCd',
    'relationType',
    'sourceAgentId',
    'sourceDesignation',
    'sourceDesignationRole',
    'subtrancheNo',
    'tier',
  ];

  protected getStepList(): StepItem[] {
    let stepList: StepItem[];
    return stepList;
  }

  constructor(
    service: ContestAndIncentiveDetailsService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
    this.isMenuOpened = true;
  }

  // protected getComponentListToDisplay() {
  //   return DynamicEvaluationComponentList.componentMap;
  // }

  ngOnInit(): void {
    super.ngOnInit();
    this.evaluationId = this.route.snapshot.paramMap.get('id');
    this.loadData(this.evaluationId);
  }
  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
  }

  menuCloseBtnClicked() {
    this.isMenuOpened = false;
  }

  menuOpenBtnClicked() {
    this.isMenuOpened = true;
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = 'Contest and Incentive Details';
    return header;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'home',
        link: '/home',
      },
      {
        id: 'Contest and Incentive Details',
      },
    ];
  }

  protected preLoad() {
    this.loadData(this.evaluationId);
  }

  protected postProcess() {
    this.loadData(this.evaluationId);
  }

  isNumber(value: any): boolean {
    return (
      value !== undefined && value !== null && value !== '' && !isNaN(Number(value)) && isFinite(Number(value))
    );
  }

  protected loadData(evaluationId, dtlData?) {
    this.resetData();
    this.service.getEvaluationDetails(evaluationId).subscribe((data) => {
      this.data = JSON.parse(JSON.stringify(data));
      if (!this.data.success) {
        alert(this.data.message);
        this.location.back();
      }
      if (
        this.data &&
        this.data.data &&
        this.data.data.Entity &&
        this.data.data.EvaluationResultDtlList != undefined
      ) {
        this.parentHeader = this.data.data.Entity.definition;
        this.data.data.EvaluationResultDtlList = this.data.data.EvaluationResultDtlList.map((item) => ({
          ...item,
          elementValue: this.formatWithCommasPreservingDecimals(item.elementValue),
        }));

        this.data.data.Entity.resultValue = this.formatWithCommasPreservingDecimals(
          this.data.data.Entity.resultValue
        );
        this.dataValues = this.data.data.EvaluationResultDtlList.map((data) => ({
          ...data,
          randomColor: this.generateReadableColor(),
        }));
        let rootNode;
        if (dtlData != undefined && dtlData.level > 0) {
          rootNode = {
            // ...this.data.data.Entity,
            level: (dtlData.level || 0) + 1,
            isMaster: true,
            children: this.data.data.EvaluationResultDtlList.map((item) => ({
              ...item,
              level: (dtlData.level || 0) + 2,
              randomColor: this.generateReadableColor(),
              isSubDetails: true,
            })),
          };

          if (!dtlData.children || dtlData.children.length === 0) {
            dtlData.children = [];
          }
          dtlData.children = [];
          dtlData.children.push(rootNode);
          this.assignRootNodeToMenu(this.menuData, dtlData);
        } else {
          this.data.data.EvaluationResultDtlList.map((item) => {
            item.level = 1;
          });
          rootNode = {
            ...this.data.data.Entity,
            level: 0,
            children: this.data.data.EvaluationResultDtlList,
            isMaster: false,
          };
          this.menuData = [rootNode];
          this.rewardValue = this.data.data.Entity.resultValue;
          this.agentId = this.data.data.Entity.agentId;
          this.agentName = this.data.data.Entity.agentName;
        }
        setTimeout(() => {
          this.toggleNodeExpansion(rootNode);
        }, 0);
      }
    });
  }

  assignRootNodeToMenu(menuData: any[], dtlData: any): void {
    const targetDefinition = dtlData.evaluationdtlId;
    const assignChildren = (nodes: any[]): boolean => {
      for (const node of nodes) {
        if (node.evaluationdtlId === targetDefinition) {
          return true;
        }
        if (node.children && node.children.length > 0) {
          if (assignChildren(node.children)) return true;
        }
      }
      return false;
    };
    assignChildren(menuData);
  }

  onNodeSelected(node: any, isAutoOpen: boolean = false) {
    if (node.objName == 'EvaluationResultDtlList') {
      if (!isAutoOpen && !node.isClickedCreatedNode) {
        this.onclickofDetails(node);
      }
      return;
    }

    if ((node.children != undefined && node.children.length > 0) || node.isMaster) {
      if (node.referenceSeq) {
        this.toggleNodeExpansion(node);
        this.loadData(node.referenceSeq, node);
      } else {
        if (this.detailsDataValues.length === 0) {
          if (node.level > 0) {
            if (node.level == 1 || node.isSubDetails) {
              if (!isAutoOpen && !node.isClickedCreatedNode) {
                this.onclickofDetails(node);
              }
            } else if (node.isMaster) {
              this.toggleNodeExpansion(node);
              this.loadData(node.evaluationId, node);
            }
          } else if (node.level == 0) {
            this.loadData(node.evaluationId);
          }
          this.resetData();
        } else {
          this.detailsDataValues = [];
          this.loadData(node.evaluationId, node);
          this.toggleNodeExpansion(node);
        }
      }
    } else {
      if (!isAutoOpen && !node.isClickedCreatedNode) {
        this.onclickofDetails(node);
      }
    }
  }

  resetData() {
    this.dataValues = [];
    this.isNodata = false;
    this.policyDataValues = [];
    this.detailsDataValues = [];
    this.detailsDataKeys = [];
    this.subMenuDataValues = [];
    this.subMenuDataKeys = [];
  }

  onclickofDetails(dtlData: any) {
    this.selectedMenuNode = dtlData;
    this.isNodata = false;
    this.resetData();
    if (dtlData.level > 0) {
      this.childHeader = dtlData.elementDescription || dtlData.definition;
      this.service.getEvaluationSubDetails(dtlData.evaluationdtlId).subscribe((subDetailsData: any) => {
        this.subtdata = JSON.parse(JSON.stringify(subDetailsData));
        if (!this.subtdata.success) {
          alert(this.subtdata.message);
          this.location.back();
        }
        let entities = this.subtdata?.data?.Entity;
        if (Array.isArray(entities)) {
          entities.forEach((entity) => {
            if (entity.policyNum != null) {
              const preferredOrders = [
                'policyNum',
                'productionEffectiveDt',
                'baseKpiOriginalValue',
                'baseKpiFinalValue',
                'agentId',
                'sourceAgentId',
                'tier',
                'sourceDesignationRole',
                'sourceDesignation',
                'relationType',
                'productCd',
                'productClass1',
                'productClass2',
                'productClass3',
                'productTypeCd',
                'policyCommencementDt',
                'policyIssueDt',
                'loginDt',
                'paymentFrequencyCd',
                'subtrancheNo',
                'policyStatusCd',
                'sumAssured',
                'annualizedPremiumAmt',
                'appropriationDt',
                'policyYearInforce',
                'premiumDueDt',
                'premiumPayingTerm',
                'premiumSubtypeCd',
                'premiumTypeCd',
                'appropriationAmt',
              ];

              const hasPreferredData = preferredOrders.some((key) => entity[key] !== null && entity[key] !== '');

              if (hasPreferredData) {
                const filteredEntity: any = {};
                preferredOrders.forEach((key) => {
                  if (entity.hasOwnProperty(key)) {
                    filteredEntity[key] = entity[key];
                  }
                });

                this.policyDataValues.push(filteredEntity);
                if (this.policyDataValues.length > 0) {
                  const allKeys = Object.keys(this.policyDataValues[0]);
                  this.preferredKeys = this.preferredOrders.filter((key) => allKeys.includes(key));
                }
              }
            } else {
              this.detailsDataKeys = Object.keys(entity).filter(
                (key) =>
                  [
                    'detailDescription',
                    'productionEffectiveDt',
                    'baseKpiOriginalValue',
                    'baseKpiFinalValue',
                  ].includes(key) && entity[key] !== null
              );
              if (this.detailsDataKeys.length != 0) {
                let childHeaderNode;
                childHeaderNode = {
                  ...entity,
                  detailDescription: dtlData.elementDescription,
                  evaluationId: dtlData.evaluationId,
                  evaluationdtlId: dtlData.evaluationdtlId,
                  level: (dtlData.level || 0) + 1,
                  randomColor: this.generateReadableColor(),
                  isSubDetails: true,
                };
                if (!dtlData.children || dtlData.children.length === 0) {
                  dtlData.children = [];
                  dtlData.children.push(childHeaderNode);
                } else {
                  const alreadyExists = dtlData.children.some(
                    (child) => child.definition === childHeaderNode.definition
                  );
                  if (!alreadyExists) {
                    dtlData.children.push(childHeaderNode);
                  }
                }
                this.detailsDataValues.push(childHeaderNode);
              } else {
                this.isNodata = true;
                this.noDataErrorMsg = 'No Data Found';
              }
            }
          });
        }
      });
    }
    this.toggleNodeExpansion(dtlData);
  }

  findNodeBydetailId(node: any, detailId: string): any {
    if (node.evaluationdtlId === detailId) {
      return node;
    }

    if (node.children && node.children.length) {
      for (let child of node.children) {
        const found = this.findNodeBydetailId(child, detailId);
        if (found) {
          return found;
        }
      }
    }

    return null;
  }

  onClickonCard(cardData: any) {
    this.isNodata = false;
    if (cardData.elementDescription !== 'Reward' && cardData.elementType == 'Production Credit') {
      this.activeCard = cardData;
      let nodeWithLevel;
      for (const rootNode of this.menuData) {
        nodeWithLevel = this.findNodeBydetailId(rootNode, cardData.evaluationdtlId);
        if (nodeWithLevel) {
          break;
        }
      }
      if (nodeWithLevel) {
        this.onclickofDetails(nodeWithLevel);
      } else {
        this.resetData();
        console.warn('No matching node found for cardData:', cardData);
      }
    } else {
      alert('No Data found this for node!');
    }
  }

  toggleNodeExpansion(dtlData: any) {
    const nodeKey = this.getNodeKey(dtlData);
    const isCurrentlyExpanded = !!this.expandedNodes[nodeKey];
    this.recursivelyCollapse(dtlData);
    if (!isCurrentlyExpanded) {
      this.expandedNodes[nodeKey] = dtlData;
      this.collapseSiblingBranches(dtlData);
    }
    this.activeNode = dtlData;
  }

  getNodeKey(node: any): string {
    return `${node.level}-${node.evaluationdtlId ?? node.elementDescription}`;
  }

  recursivelyCollapse(node: any) {
    const nodeKey = this.getNodeKey(node);
    delete this.expandedNodes[nodeKey];
    if (node.children && node.children.length > 0) {
      node.children.forEach((child: any) => this.recursivelyCollapse(child));
    }
  }

  collapseSiblingBranches(node: any) {
    const currentLevel = node.level;
    Object.keys(this.expandedNodes).forEach((key) => {
      if (key.startsWith(`${currentLevel}-`) && key !== this.getNodeKey(node)) {
        const sibling = this.expandedNodes[key];
        this.recursivelyCollapse(sibling);
      }
    });
  }

  generateReadableColor(): string {
    const min = 60;
    const max = 200;
    const r = Math.floor(Math.random() * (max - min) + min);
    const g = Math.floor(Math.random() * (max - min) + min);
    const b = Math.floor(Math.random() * (max - min) + min);
    return `rgb(${r}, ${g}, ${b})`;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  shouldDisplayKey(key: string): boolean {
    return !this.excludedKeys.includes(key);
  }

  sortKeys = (a: KeyValue<string, any>, b: KeyValue<string, any>): number => {
    if (a.key === 'sumAssured') return -1;
    if (b.key === 'sumAssured') return 1;

    return a.key.localeCompare(b.key);
  };

  onValueClick(rowData): void {
    this.resetData();
    this.parentNode = this.selectedMenuNode;
    if (!this.parentNode.children) {
      this.parentNode.children = [];
    } else {
      this.parentNode.children = [];
    }

    let newChildNode;
    newChildNode = {
      ...rowData,
      elementDescription: rowData.elementDescription,
      elementValue: rowData.baseKpiFinalValue,
      level: (this.parentNode.level || 0) + 1,
      children: [rowData],
      randomColor: this.generateReadableColor(),
      referenceSeq: rowData.referenceSeq,
      elementType: rowData.elementType || 'Production Credit',
      isClickedCreatedNode: true,
    };
    this.parentNode.children = [newChildNode];
    setTimeout(() => {
      newChildNode.expanded = !newChildNode.expanded;
      this.onNodeSelected(newChildNode, true);
    }, 0);
  }

  protected postLoadCompanyFacets() {}

  goBack(): void {
    this.location.back();
  }
  formatWithCommasPreservingDecimals(value: any) {
    if (value === null || value === undefined) return value;

    // If value is not a valid number, return as is
    if (isNaN(Number(value))) return value;

    const strValue = value.toString();
    const [integerPart, decimalPart] = strValue.split('.');

    const formattedInteger = Number(integerPart).toLocaleString('en-US');

    return decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger;
  }
}
